<template>
  <nav class="nav">
    <div class="nav-left">
      <nuxt-link to="/" class="bambee_logo">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="270"
          height="83"
          viewBox="0 0 270 83"
        >
          <g fill="#694981" fill-rule="evenodd">
            <path
              d="M130.52289,23.2023417 L152.315628,23.2023417 C151.643502,17.6790005 147.013225,13.3894973 141.419435,13.3894973 C135.825645,13.3894973 131.195066,17.6790005 130.52289,23.2023417 M141.776544,38.5775192 C141.588156,38.5775192 141.451292,38.5717483 141.374031,38.5673824 C133.809869,38.5419398 127.663508,32.2818687 127.663508,24.5903908 C127.663508,16.8833061 133.834252,10.6133992 141.419435,10.6133992 C149.004316,10.6133992 155.17506,16.8833061 155.17506,24.5903908 C155.17506,25.3569291 154.553706,25.9784398 153.787361,25.9784398 L130.52289,25.9784398 C131.195066,31.5017811 135.825645,35.7912843 141.419435,35.7912843 C141.455356,35.7912843 141.491629,35.7926392 141.5275,35.795349 C141.761292,35.8129631 147.483467,36.130167 151.062485,30.2174594 C151.459178,29.5613728 152.312618,29.3519611 152.968137,29.7487544 C153.623707,30.1459492 153.833417,30.999203 153.436724,31.6549382 C149.539579,38.0932577 143.501986,38.5775192 141.776544,38.5775192 Z M172.561403,38.5775192 C172.373015,38.5775192 172.236152,38.5717483 172.15889,38.5673824 C164.594729,38.5419398 158.448368,32.2818687 158.448368,24.5903908 C158.448368,16.8833061 164.619111,10.6133992 172.204294,10.6133992 C179.789527,10.6133992 185.96027,16.8833061 185.96027,24.5903908 C185.96027,25.3569291 185.338917,25.9784398 184.572572,25.9784398 L161.307749,25.9784398 C161.979925,31.5017811 166.610504,35.7912843 172.204294,35.7912843 C172.240216,35.7912843 172.276489,35.7926392 172.31236,35.795349 C172.547155,35.8129631 178.268677,36.130167 181.847345,30.2174594 C182.244038,29.5617241 183.097477,29.3519611 183.752997,29.7487544 C184.408567,30.1459492 184.618277,30.999203 184.221583,31.6549382 C180.324789,38.0932577 174.287197,38.5775192 172.561403,38.5775192 Z M161.307749,23.2023417 L183.100839,23.2023417 C182.428713,17.6790005 177.798084,13.3894973 172.204294,13.3894973 C166.610504,13.3894973 161.979925,17.6790005 161.307749,23.2023417 Z M0.772818832,24.893122 L0.772818832,24.1905664 L0.772818832,1.51829555 C0.772818832,0.751757256 1.41123043,0.130246497 2.1775752,0.130246497 C2.95214783,0.130246497 3.58233157,0.751757256 3.58233157,1.51829555 L3.58233157,16.1155433 C6.09082508,12.7182356 10.1412394,10.5174803 14.6501561,10.5174803 C22.2760768,10.5174803 28.4802334,16.8105213 28.4802334,24.5457082 C28.4802334,32.2808951 22.2760768,38.5739362 14.6501561,38.5739362 C10.1412394,38.5739362 6.09082508,36.3731809 3.58233157,32.9758731 L3.58233157,37.2603079 C3.58233157,38.0268462 2.94391997,38.6483569 2.1775752,38.6483569 C1.4174515,38.6483569 0.772818832,37.9937759 0.772818832,37.2603079 L0.772818832,24.893122 Z M14.6501561,13.2935784 C8.5993186,13.2935784 3.58233157,18.3192092 3.58233157,24.5418442 C3.58233157,30.7644792 8.65696378,35.7978883 14.6501561,35.7978883 C20.7554782,35.7978883 25.7048362,30.7601133 25.7048362,24.5457082 C25.7048362,18.3313032 20.7554782,13.2935784 14.6501561,13.2935784 Z M96.7979556,24.893122 L96.7979556,24.1905664 L96.7979556,1.51829555 C96.7979556,0.751757256 97.4363672,0.130246497 98.2027119,0.130246497 C98.9772846,0.130246497 99.6074683,0.751757256 99.6074683,1.51829555 L99.6074683,16.1155433 C102.115962,12.7182356 106.166376,10.5174803 110.675293,10.5174803 C118.301214,10.5174803 124.50537,16.8105213 124.50537,24.5457082 C124.50537,32.2808951 118.301214,38.5739362 110.675293,38.5739362 C106.166376,38.5739362 102.115962,36.3731809 99.6074683,32.9758731 L99.6074683,37.2603079 C99.6074683,38.0268462 98.9690567,38.6483569 98.2027119,38.6483569 C97.4425882,38.6483569 96.7979556,37.9937759 96.7979556,37.2603079 L96.7979556,24.893122 Z M110.675293,13.2935784 C104.624455,13.2935784 99.6074683,18.3192092 99.6074683,24.5418442 C99.6074683,30.7644792 104.682101,35.7978883 110.675293,35.7978883 C116.780615,35.7978883 121.729973,30.7601133 121.729973,24.5457082 C121.729973,18.3313032 116.780615,13.2935784 110.675293,13.2935784 Z M58.0668308,10.1937326 C58.8331755,10.1937326 59.461804,10.8289934 59.461804,11.5955317 L59.4658176,37.260338 C59.4658176,38.0268763 58.8331755,38.6483368 58.0668308,38.6483368 C57.300486,38.6483368 56.6620744,38.0268763 56.6620744,37.260338 L56.6620744,32.83479 C54.1535809,36.3117374 50.1004574,38.5739663 45.5296812,38.5739663 C37.9037606,38.5739663 31.7155579,32.2809253 31.7155579,24.5456882 C31.7155579,16.8105515 37.9090786,10.5175104 45.5349992,10.5175104 C50.1057754,10.5175104 54.1535809,12.7796891 56.6620744,16.2566868 L56.6620744,11.581581 C56.6620744,10.8150427 57.300486,10.1937326 58.0668308,10.1937326 Z M45.5562712,35.7978682 C51.6615933,35.7978682 56.6109513,30.7601434 56.6109513,24.5456882 C56.6109513,18.3313333 51.6615933,13.2935583 45.5562712,13.2935583 C39.4509492,13.2935583 34.5015912,18.3313333 34.5015912,24.5456882 C34.5015912,30.7601434 39.4509492,35.7978682 45.5562712,35.7978682 Z M65.7428209,37.2380369 C65.7399612,37.8904099 65.2666587,38.6406388 64.3380646,38.6418934 C63.4227153,38.643148 62.9361679,37.8904099 62.9333082,37.2380369 C62.9049622,30.8240057 62.9333082,11.5815609 62.9333082,11.5815609 C62.9333082,10.8150226 63.5702147,10.1935118 64.3365595,10.1935118 C65.1029042,10.1935118 65.7428209,10.8150226 65.7428209,11.5815609 L65.7428209,13.7911985 C67.2980869,12.4225199 69.1851764,11.5842707 71.3252726,11.5842707 C74.2015112,11.5842707 76.8738094,13.0853811 78.3354584,15.3675324 C79.7971074,13.0853811 82.2044083,11.5842707 85.0806469,11.5842707 C89.5970891,11.5842707 93.2359098,15.3132851 93.2359098,19.896607 L93.2860797,37.2398936 C93.2860797,38.0064319 92.6475678,38.6418934 91.881223,38.6418934 C91.1148782,38.6418934 90.476567,38.0268562 90.476567,37.2603179 L90.476567,19.896607 C90.476567,16.8440031 88.0161864,14.3996116 85.0300757,14.3996116 C82.043965,14.3996116 79.7371042,16.8440031 79.7371042,19.896607 C79.7371042,19.896607 79.7403652,32.9026167 79.7407666,37.2380369 C79.7408669,37.8573898 79.2825652,38.6418934 78.3391709,38.6418934 C77.4370665,38.6418934 76.9375251,37.8664728 76.9375251,37.2379867 C76.9375251,32.9026167 76.930702,19.896607 76.930702,19.896607 C76.930702,16.8440031 74.3479571,14.3996116 71.3618464,14.3996116 C68.3757357,14.3996116 65.7428209,16.8440031 65.7428209,19.896607 C65.7428209,19.896607 65.7619858,32.902717 65.7428209,37.2380369 Z"
              transform="translate(84 22)"
            />
            <path
              d="M52.7318756,51.0733547 C47.7831502,51.0733547 40.3298599,42.2944753 39.6105287,41.4331742 L39.5430507,41.3591205 L39.6105287,41.2850668 C40.3298599,40.4238158 47.7831502,31.6449365 52.7318756,31.6449365 C57.9356631,31.6449365 62.0987333,35.808151 62.0987333,41.3591205 C62.0987333,46.9101402 57.9356631,51.0733547 52.7318756,51.0733547 L52.7318756,51.0733547 Z M46.2751033,53.1563919 C46.2751033,58.6948184 42.5762521,62.8712783 37.6443335,62.8712783 C33.1199923,62.8712783 29.3177918,58.4224351 29.3177918,53.1563919 L29.3177918,51.4622372 C30.7225395,50.6205533 31.9042334,49.5585144 33.3177607,48.260818 C35.3915195,46.3569447 37.0718486,44.4697285 37.81491,43.6058686 C38.5579714,44.4697285 40.219537,46.3569447 42.293346,48.260818 C43.7068734,49.5585144 44.9205252,50.6205031 46.2751033,51.4622372 L46.2751033,53.1563919 Z M13.5298826,41.3591205 C13.5298826,35.808151 17.6929528,31.6449365 22.8967403,31.6449365 C27.8454658,31.6449365 35.298756,40.4237657 36.0180872,41.2850668 L36.078993,41.3591205 L36.0180872,41.4331742 C35.298756,42.2945255 27.8454658,51.0733547 22.8967403,51.0733547 C17.6929528,51.0733547 13.5298826,46.9101402 13.5298826,41.3591205 L13.5298826,41.3591205 Z M29.3177918,30.0413922 C29.3177918,24.775349 33.1199923,20.3265057 37.6443335,20.3265057 C42.5762521,20.3265057 46.2751033,24.5029657 46.2751033,30.0413922 L46.2751033,31.256054 C44.9205252,32.0977379 43.7065723,33.1597266 42.293045,34.457423 C40.219236,36.3613465 38.5478873,38.2485125 37.8048259,39.1123724 C37.0617645,38.2485125 35.3868036,36.3613465 33.3129946,34.457423 C31.8994673,33.1597266 30.7225395,32.0977379 29.3177918,31.256054 L29.3177918,30.0413922 Z M52.7318756,28.8694266 C51.594331,28.8694266 50.3805788,29.1516436 49.0814882,29.7143215 C48.9329362,22.7575854 44.07572,17.5510461 37.6621939,17.5510461 C31.6270466,17.5510461 26.702854,22.9781913 26.5474789,29.7144219 C25.2482879,29.1516938 24.0344354,28.8694266 22.8967403,28.8694266 C16.0880285,28.8694266 10.7545527,34.3555238 10.7545527,41.3591205 C10.7545527,48.3627172 16.0972096,53.8488645 22.9059715,53.8488645 C24.0414592,53.8488645 25.1537183,53.5677012 26.558466,53.0071305 L26.558466,53.1563919 C26.558466,60.0436399 31.561776,65.6467882 37.694503,65.6467882 C44.208569,65.6467882 49.1347683,60.2770396 49.1347683,53.1563919 L49.1347683,53.0071305 C50.4893464,53.5677514 51.619466,53.8488645 52.7550038,53.8488645 C59.5637155,53.8488645 64.8856524,48.3627172 64.8856524,41.3591205 C64.8856524,34.3555238 59.5405874,28.8694266 52.7318756,28.8694266 L52.7318756,28.8694266 Z M37.814308,2.80056603 C35.8815256,2.80056603 33.9487433,3.2181468 32.5115861,4.05310765 L8.0845287,18.2446827 C5.20670236,19.9166615 2.77538511,24.1405339 2.77538511,27.4682859 L2.77538511,55.571828 C2.77538511,58.8962185 5.21447864,63.0984166 8.10148601,64.7483699 L32.4773704,78.6779974 C35.3702978,80.3310614 40.2583181,80.3310614 43.1512455,78.6779974 L67.5271299,64.7483699 C70.4141373,63.0984166 72.8532308,58.8962185 72.8532308,55.571828 L72.8532308,27.4682859 C72.8532308,24.1408851 70.4219136,19.9166615 67.5439367,18.2446827 L43.1170298,4.05310765 C41.6798726,3.2181468 39.7470903,2.80056603 37.814308,2.80056603 M37.814308,82.7013327 C35.3982423,82.7013327 32.9829793,82.1636404 31.1003665,81.0876036 L6.72463259,67.157976 C2.9537379,65.0031428 5.01695604e-06,59.9139556 5.01695604e-06,55.571828 L5.01695604e-06,27.4682859 C5.01695604e-06,23.1302222 2.93883754,18.0244281 6.69041695,15.8445591 L31.1174743,1.6533854 C34.8726158,-0.528540604 40.7560001,-0.528540604 44.5111416,1.6533854 L68.938199,15.8445591 C72.6899791,18.0247793 75.6286109,23.1302222 75.6286109,27.4682859 L75.6286109,55.571828 C75.6286109,59.9139556 72.674878,65.0031428 68.9041338,67.157976 L44.5280989,81.0876036 C42.6459377,82.1632892 40.2297215,82.7013327 37.814308,82.7013327"
            />
          </g>
        </svg>
      </nuxt-link>
    </div>

    <!-- This "nav-menu" is hidden on mobile -->
    <!-- Add the modifier "is-active" to display it on mobile -->
    <div class="nav-right nav-menu" :class="{ 'is-active': toggle_nav }">
      <div class="nav-inner">
        <div class="nav-inner-left" />
        <div class="nav-inner-right">
          <div class="nav-item">
            <nuxt-link id="goto-employee-signup" to="/activation">
              <bam-button class="button is-primary is-small">
                Employee Signup
              </bam-button>
            </nuxt-link>
          </div>

          <div class="nav-item">
            <bam-button
              id="goto-company-signup"
              class="button is-success is-small"
              @click="handle_registration"
            >
              Company Signup
            </bam-button>
          </div>
        </div>
      </div>
    </div>

    <div class="bambee-nav-burger">
      <span
        id="nav-toggle"
        class="nav-toggle"
        :class="{ 'is-active': toggle_nav }"
        @click="handle_toggle_nav"
      >
        <span class="line" />
        <span class="line" />
        <span class="line" />
      </span>
    </div>
  </nav>
</template>

<script>
export default {
  props: ['toggle_nav'],
  methods: {
    handle_toggle_nav() {
      this.$emit('handle_toggle_nav', !this.toggle_nav);
    },
    handle_registration() {
      window.location.href = `//${process.env.www}/registration/customer/`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~assets/css/shared.scss';

.nav {
  align-items: center;
  background-color: $white;
  display: flex;
  height: $header-height;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 20;
  @include shadow-2dp();
}

.nav-left {
  flex-basis: auto;
  flex-grow: 0;
  flex-shrink: 0;
}

.nav-inner {
  display: flex;
  flex: 1 1 100%;
  height: $header-height;

  .nav-inner-left {
    display: flex;
    flex: 1 1 auto;
  }

  .nav-inner-right {
    align-items: center;
    display: flex;
    flex: 0 0 auto;

    span {
      color: #3f3f40;
    }
  }
  @media screen and (max-width: 768px) {
    align-content: flex-start;
    flex-wrap: wrap;
    height: calc(100vh - #{$header-height});
    overflow-x: hidden;
    @include overflow(auto);

    .nav-inner-left {
      align-content: flex-start;
      flex: 0 0 100%;
      flex-wrap: wrap;
    }

    .nav-inner-right {
      align-content: flex-start;
      flex: 0 0 100%;
      flex-wrap: wrap;
    }
  }
}

.nav-item {
  line-height: 1.1rem;
  padding: 0;

  a:not(.button) {
    color: $purple;
    font-weight: 600;
    transition: opacity $time $ease;

    &:hover,
    &:focus {
      opacity: 0.5;
    }
  }

  .nav-center & {
    @media screen and (max-width: 1199px) {
      padding: 0 1.4rem;
    }
  }
  @media screen and (max-width: 768px) {
    align-content: flex-start;
    align-items: flex-start;
    flex: 0 0 100%;
    font-size: 1.4rem;
    justify-content: center;
    //margin-bottom:   .5rem;
    padding: 1rem 0;

    a:not(.button) {
      padding: 1rem 0;
    }
  }
}

.nav-item + .nav-item {
  margin-left: 8px;
}

.nav-item:last-child {
  margin-right: 16px;
}

.nav-menu {
  @media screen and (max-width: 768px) {
    // height: calc(100vh - #{$header-height});
    @include shadow-2dp();
  }
  @media screen and (max-width: 1007px) {
    padding-right: 0;
  }
}

.bambee_logo {
  align-items: center;
  display: flex;
  justify-content: flex-start;
  margin-right: 1rem;
  padding-left: 1.5rem;
  @media screen and (max-width: 1199px) {
    margin-right: 1.5rem;
  }
  //@media screen and (max-width: 1007px) {
  //	margin-right: 2rem;
  //}

  svg {
    height: $header-height - 1.5rem;
    width: $header-height * 2;
  }
}

.urgent-need {
  align-items: center;
  display: none;
  flex-wrap: wrap;
  height: $header-height;
  justify-content: center;

  a {
    color: $purple;
    font-weight: 600;
  }

  &.is-smaller {
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 0;
    margin-right: 2rem;
  }

  div {
    padding: 0 1rem;

    span {
      color: $purple;
      display: block;
      font-size: 0.8rem;
      font-weight: 600;

      + span {
        color: $text;
        font-weight: 400;

        + span {
          color: $purple;
          font-size: 1rem;
          font-weight: 600;
        }
      }
    }
  }
  @media screen and (max-width: 768px) {
    display: flex;
    flex: 0 0 100%;
    justify-content: center;
    margin-bottom: 1rem;

    div {
      span {
        font-size: 1.1rem;

        + span + span {
          font-size: 1.3rem;
        }
      }
    }
  }
  @media screen and (min-width: $tablet) and (max-width: $laptop - 1px) {
    background: white;
    border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
    display: flex;
    position: fixed;
    right: 4rem;
    top: $header-height;
    @include shadow-2dp();
  }
  @media screen and (max-width: $laptop) {
    display: flex;
  }
}

.nav .nav-right.nav-menu {
  align-items: center;
  display: flex;
  width: 100%;
}

//Bambee Burger Menu Toggle

.bambee-nav .bambee-nav-burger {
  display: none;
}

//Bambee Mobile Menu
/*.bambee-nav .bambee-nav-mobile-menu {
    display: none;
  }*/

//Nav menu Toggle

.nav-toggle {
  cursor: pointer;
  display: inline-block;
  height: 24px;
  line-height: 8px;
  margin-right: 1.5rem;
  transition: 1s;
  width: 24px;

  .line {
    border-top: 2.4px solid $primary;
    display: inline-block;
    position: relative;

    transition: 0.5s ease;
    vertical-align: middle;

    width: 80%;

    &:first-child {
      transform: translateY(1.2px);
    }

    &:last-child {
      transform: translateY(-1.2px);
    }
  }
}

.nav-toggle {
  &:hover {
    .line:first-child,
    .line:last-child {
      transform: translateY(0);
    }
  }
}

.nav .bambee-nav-burger {
  display: none;
}

@media screen and (max-width: 768px) {
  .nav {
    justify-content: space-between;
    position: relative;
  }

  .nav .bambee-nav-burger {
    display: inline-block;
  }

  .nav .nav-right.nav-menu {
    display: none;
  }

  .nav .nav-right.nav-menu.is-active {
    background-color: $white-grey-2;
    display: block;
    height: calc(100vh - 4.5rem + 3px);
    position: absolute;
    top: calc(4.5rem + 3px);
    width: 100%;

    .nav-inner {
      align-items: center;
      display: flex;
      padding-top: 2rem;
      text-align: center;
    }
  }
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .nav .nav-right.nav-menu {
    .nav-inner-right .nav-item .field {
      margin-bottom: 0 !important;
    }
  }
}
</style>
